import { colors } from './colors';
import { icons } from './icons';
import { typography } from './typography';
import { zIndex } from './zIndex';

export { colors, icons, typography, zIndex };
